import React, { useContext, useState } from "react";
import { ReactComponent as Business } from "../../../assets/novosicones/notificacoes/highlight.svg";

import { ContextNotificacoes } from "../../../services/notificacoes";
import { useHistory } from "react-router-dom";
import { Spinner } from "../../StyledComponent";
export default function ContratoFinanciamento({ tema, setNotificationsModal }) {
  const {
    marcarNotificacaoContratoFinanciamentoLida,
    atualizaNotificacoes,
    // handleNotificationError,
  } = useContext(ContextNotificacoes);

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const NOTIFICACOES_CONTRATO_FINANCIAMENTO = JSON.parse(
    sessionStorage.getItem("notificacoesContratoFinanciamento")
  )?.filter(contrato => contrato?.GeraNotificacaoContratoRegistrado);

  const handleVisualizar = async (idNotificacao) => {
    setLoading(true);

    history.push("/meu-imovel", { documentos: true });

    setNotificationsModal(false);
    await marcarNotificacaoContratoFinanciamentoLida(idNotificacao);
    await atualizaNotificacoes();
    setLoading(false);
  };
  
  return (
    NOTIFICACOES_CONTRATO_FINANCIAMENTO?.length > 0 && (
      <div className="notifications__item" style={{ marginTop: "24px" }}>
        <span
          className="notifications__item__title"
          style={{ color: tema.primaryColor }}
        >
          Contrato Registrado:
        </span>
        {NOTIFICACOES_CONTRATO_FINANCIAMENTO.map((contrato) => {
          return (
            <div className="centralized-space-between" key={contrato.Id}>
              <div className="centralized">
                <span
                  style={{ width: "24px", height: "24px", display: "block" }}
                >
                  <Business style={{ fill: tema.primaryColor }} />
                </span>
                <p
                  className="notifications__item__description"
                  style={{ color: "#454545" }}
                >
                  Olá cliente! Seu contrato de Financiamento está registrado, acesse agora e visualize sua via digital.
                </p>
              </div>
              <a
                onClick={() => handleVisualizar(contrato.Id)}
                style={{ color: tema.primaryColor, cursor: "pointer" }}
              >
                {loading ? <Spinner /> : "VISUALIZAR"}
              </a>
            </div>
          );
        })}
      </div>
    )
  );
}
